import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Input from "../components/shared/input";
import Button from "../components/shared/button";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import axios from "axios";

const Newpassword = () => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const { userEmail, otp } = location.state || {};

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setError("");
    setLoading(true);

    const url = `${process.env.REACT_APP_NODE_BASE_URL}/user/forgot-password`;

    try {
      console.log("Inside api call")
      const response = await axios.post(url, {
        email: userEmail,
        otp,
        password,
      });

      if (response.status === 200) {
        toast.success("Password reset successfully!");
        navigate("/login");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Password reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col lg:flex-row min-h-screen items-center max-md:gap-[60px] max-md:justify-start justify-center bg-lightwhite p-[20px]">
      <div className="max-md:min-h-[10vh] max-md:border-none min-h-[80vh] border-solid border-r-2 border-r-gray-200 flex flex-col items-center justify-center w-full md:w-1/2 ">
        <img
          src="../../assets/images/dashboard/logo_large.png"
          alt="logo"
          className="w-100 h-100 max-md:w-[60px] max-md:h-[60px]"
        />
        <p className="text-blue font-bold text-[34px] max-md:text-[18px]">
          {t("newpassword.leftSide.title")}
        </p>
      </div>

      {/* Right side*/}
      <div className="flex flex-col items-center justify-center w-full md:w-1/2 ">
        <div className="w-full max-w-sm">
          <h4 className="small font-bold text-black">
            {t("newpassword.rightSide.title")}
          </h4>
          <p className="text-lightgray small leading-[15px]">
            {t("newpassword.rightSide.desc")}
          </p>

          <form onSubmit={(e) => handleResetPassword(e)} className="mt-[35px]">
            <div className="flex flex-col gap-[18px]">
              <Input
                label="Enter New Password"
                type="password"
                name="password"
                placeholder={t("newpassword.rightSide.passwordPlaceholder")}
                icon="mingcute:eye-2-fill"
                leftImg="../../assets/icons/Unlock.svg"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Input
                label="Confirm Password"
                type="password"
                name="confirmPassword"
                placeholder={t("newpassword.rightSide.confirmPasswordPlaceholder")}
                icon="mingcute:eye-2-fill"
                leftImg="../../assets/icons/Unlock.svg"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {error && <p className="text-red-500 text-sm">{error}</p>}
            </div>

            <Button
              text={t("newpassword.rightSide.confirm")}
              className="button btn-blue w-full mt-[38px]"
              height={50}
              disabled={loading}
            />
          </form>
          {/* <p className="small flex justify-center gap-[4px] m-auto mt-[8px]">
            {t("newpassword.rightSide.noAccount")}
            <a href="/signup" className="font-semibold">
              {t("newpassword.rightSide.signup")}
            </a>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default Newpassword;